module.exports = __webpack_public_path__ + "img/Down.61596a01.svg";